"use client";
import { useMutation } from "@apollo/client";
import { toast } from "react-toastify";

import { CLICK_BANNER } from "@/graphql/mutation/stocks";

// import { useEffect } from "react"

const adSizes = {
  banner: { width: 728, height: 90, className: "w-full h-24 max-w-4xl" },
  rectangle: { width: 300, height: 250, className: "w-full max-w-sm h-64" },
  leaderboard: { width: 728, height: 90, className: "w-full h-20 max-w-3xl" },
  skyscraper: { width: 160, height: 600, className: "w-40 h-96" },
  square: { width: 250, height: 250, className: "w-64 h-64" },
};

// export default function AdBlock({
//   size,
//   position,
//   className = "",
//   adClient = "ca-pub-XXXXXXXXXXXXXXXX", // Your AdSense Publisher ID
//   adSlot = "XXXXXXXXXX", // Default ad slot ID
// }) {
//   const sizeInfo = adSizes[size]
//   console.log("🚀 ~ sizeInfo:", sizeInfo)

//   // Load AdSense script once when component mounts
//   useEffect(() => {
//     // Check if the script is already added to avoid duplicates
//     const existingScript = document.querySelector('script[src*="adsbygoogle"]')
//     if (!existingScript) {
//       const script = document.createElement("script")
//       script.src = "https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js"
//       script.async = true
//       script.crossOrigin = "anonymous"
//       document.head.appendChild(script)
//     }

//     // Initialize ads
//     try {
//       (window.adsbygoogle = window.adsbygoogle || []).push({})
//     } catch (error) {
//       console.error("AdSense error:", error)
//     }
//   }, [])

//   return (
//     <div className={`${className} flex justify-center`}>
//       <div className={`${sizeInfo.className} overflow-hidden`} role="banner" aria-label={`Advertisement ${position}`}>
//         <ins
//           className="adsbygoogle"
//           style={{
//             display: "block",
//             width: `${sizeInfo.width}px`,
//             height: `${sizeInfo.height}px`,
//           }}
//           data-ad-client={adClient}
//           data-ad-slot={adSlot}
//           data-ad-format="auto"
//           data-full-width-responsive="true"
//         ></ins>
//       </div>
//     </div>
//   )
// }

export default function AdBlock({
  size,
  position,
  className = "",
  addBanners,
}) {
  const sizeInfo = adSizes[size];
  const [clickBanner] = useMutation(CLICK_BANNER);

  const handleBannerClick = (bannerId) => {
    clickBanner({ variables: { bannerId } }).catch((err) => {
      toast.error(err?.message);
    });
    if (addBanners?.bannerLink) {
      window.open(addBanners?.bannerLink, "_blank");
    }
  };

  return (
    <div
      className={`${className} d-flex justify-content-center align-items-center`}
    >
      <div
        className={`${sizeInfo.className} bg-gray-200 border-2 w-100 border-dashed border-gray-300 d-flex ${addBanners?.bannerLink ? "cursor-pointer" : ""} justify-content-center align-items-center rounded-lg`}
        role="banner"
        aria-label={`Advertisement ${position}`}
        onClick={() => handleBannerClick(addBanners?._id)}
      >
        {/* <div className="text-center text-gray-500"> */}
        {/* <div className="text-sm font-medium">Advertisement</div> */}
        <img
          className="rounded-lg max-w-100"
          src={`${process.env.NEXT_PUBLIC_API_URL}/assets/${addBanners?.bannerImage}`}
          alt={addBanners?.bannerName}
        />
        {/* </div> */}
      </div>
    </div>
  );
}
